// galaxy.js: chapter 2 SCALE. Rise from the Sun's neighbourhood out of the Milky
// Way to a face-on barred spiral ("You are here"), then dive to the core.
// Implementation lives in ./galaxy/ (model, maps, stars, glow, sky, camera, world).
// Params: shiftX, shiftY (fractions of the frame; subject moves right / down).
// Anchors: sun (= here), core.
export { create } from './galaxy/world.js';
